import { createRef } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const defaultStyle = (duration) => ({
  transition: `transform ${duration}ms ease-in-out`,
  transform: 'translate(0, -100%)',
});

const transitionStyles = {
  entering: { transform: 'translate(0, 50px)' },
  entered: { transform: 'translate(0, 50px)' },
  exiting: { transform: 'translate(0, -110%)' },
  exited: { transform: 'translate(0, -110%)' },
};

const SlideInOut = ({
  className,
  durationIn,
  durationOut,
  in: inProp,
  children,
  ...rest
}) => {
  const transitionChildRef = createRef();
  return (
    <Transition
      in={inProp}
      nodeRef={transitionChildRef}
      timeout={{
        enter: durationIn,
        exit: durationOut,
      }}
      unmountOnExit
      {...rest}
    >
      {(state) => (
        <div
          ref={transitionChildRef}
          className={className}
          style={{
            ...defaultStyle(inProp ? durationIn : durationOut),
            ...transitionStyles[state],
          }}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

SlideInOut.propTypes = {
  className: PropTypes.string,
  durationIn: PropTypes.number,
  durationOut: PropTypes.number,
  children: PropTypes.node.isRequired,
  in: PropTypes.bool.isRequired,
};

SlideInOut.defaultProps = {
  className: undefined,
  durationIn: 300,
  durationOut: 200,
};

export default SlideInOut;
